import { defineColumn, type StrictColumnDef } from '../../../../components/tanstack-table/column';
import { unitPrice } from '../../../../data/product';
import { shortCurrencyFormatter } from '../../../../helpers/format-currency';
import type { ProductOrderItem } from '../data/product-order-item';

function computeOpportunityCost(item: ProductOrderItem): number {
  const { product } = item;
  const qohUnits = Math.max(0, product.inventory_qty);
  const projectedUnits = product.stats.last_year_next_30;
  const atRiskUnits = Math.max(0, projectedUnits - qohUnits);

  return atRiskUnits * unitPrice(product);
}

export const OpportunityCost: StrictColumnDef<ProductOrderItem> = defineColumn<ProductOrderItem>({
  id: 'Opp. Cost',
  minWidth: 55,
  accessorFn: (item) => shortCurrencyFormatter(computeOpportunityCost(item)),
  sortKeyFn: computeOpportunityCost,
  gloss:
    "Projected lost revenue in the next 30 days if current stock can't cover demand, based on same-period sales last year valued at selling price",
});
